import { Button } from "./Button";
import { Link } from "./Link";
import { Tag } from "./Tag";
import { TooltipIcon } from "./TooltipIcon";
import { FormLabel } from "./FormLabel";
import { Input } from "./Input";

const Tooltip = {
  baseStyle: {
    fontWeight: 400,
    fontSize: "12px",
    fontFamily: "Poppins",
  },
};

export const customComponents = {
  Button,
  Link,
  Tag,
  TooltipIcon,
  Input,
  FormLabel,
  Tooltip,
};
